module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-ramen-282bf6c2157c0f73a6d06f231895fe90.png";